function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var QUOTE_TTL_MS = 25 * 60 * 1000;
function canonicalJson(value) {
  if (Array.isArray(value)) {
    return "[".concat(value.map(function (item) {
      return canonicalJson(item);
    }).join(','), "]");
  }
  if (value && _typeof(value) === 'object') {
    return "{".concat(Object.keys(value).sort().map(function (key) {
      return "".concat(JSON.stringify(key), ":").concat(canonicalJson(value[key]));
    }).join(','), "}");
  }
  return JSON.stringify(value);
}
function quoteTimestamp() {
  var now = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Date.now();
  var sequence = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var time = Number(now);
  var suffix = Number(sequence) || 0;
  return "".concat(time, "-").concat(suffix);
}
function quoteTime(timestamp) {
  var time = Number(String(timestamp || '').split('-')[0]);
  return Number.isFinite(time) ? time : NaN;
}
function quoteIsExpired(timestamp) {
  var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
  var time = quoteTime(timestamp);
  return !Number.isFinite(time) || now - time > QUOTE_TTL_MS;
}
function signQuote(crypto, data, privateKey) {
  return crypto.signMessage(canonicalJson(data), privateKey);
}
function verifyQuote(app, data, signature, publicKey) {
  var _app$crypto;
  if (!data || !signature || !publicKey || !(app !== null && app !== void 0 && (_app$crypto = app.crypto) !== null && _app$crypto !== void 0 && _app$crypto.verifyMessage)) {
    return false;
  }
  try {
    return app.crypto.verifyMessage(canonicalJson(data), signature, publicKey) === true;
  } catch (err) {
    return false;
  }
}
module.exports = {
  QUOTE_TTL_MS: QUOTE_TTL_MS,
  canonicalJson: canonicalJson,
  quoteTimestamp: quoteTimestamp,
  quoteIsExpired: quoteIsExpired,
  signQuote: signQuote,
  verifyQuote: verifyQuote
};